module.exports = __webpack_public_path__ + "img/km.d7b474ee.svg";